// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendee-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 3px 0;
  margin: 0 20px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
}
.attendee-item:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}
.attendee-item .user-icon-container {
  display: flex;
}
.attendee-item .user-icon-container .user-icon {
  font-size: 36px;
  color: #ed143d;
}
.attendee-item ion-label {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.attendee-item .attendee-item-actions {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
}
.attendee-item .attendee-item-actions ion-badge {
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 10px;
}
.attendee-item .attendee-item-actions .close-icon-container {
  display: flex;
}
.attendee-item .attendee-item-actions .close-icon-container ion-icon {
  font-size: 24px;
  color: #ed143d;
}

ion-searchbar {
  --background: white;
  --icon-color: #ed143d;
  --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);
  padding: 5px 10px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}

.split-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
}

.colleagues-section {
  flex: 1;
  overflow-y: auto;
  border-bottom: 1px solid var(--ion-color-light);
}

.bookings-section {
  flex: 3;
  overflow-y: auto;
  padding-bottom: 120px;
}

.spinner-background {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-card {
  margin: 20px;
}
ion-card ion-card-header {
  padding: 0 10px;
}
ion-card ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  justify-content: center;
}
ion-card ion-card-header ion-card-title .map-icon {
  font-size: 40px;
  padding-right: 8px;
}
ion-card ion-card-header ion-card-title ion-label {
  font-size: 1rem;
  flex-grow: 3;
  margin-bottom: 5px;
}
ion-card ion-card-header ion-card-title ion-label small {
  display: block;
  color: #6e6e6e;
  font-size: 12px;
  margin-top: 5px;
  font-weight: 500;
}
ion-card ion-card-header ion-card-title ion-label small ion-icon {
  font-size: 15px;
  vertical-align: text-top;
  margin-right: 3px;
}
ion-card ion-card-header ion-card-title .phone-icon {
  margin: 5px 0 0 auto;
  font-size: 24px;
  cursor: pointer;
}
ion-card ion-card-header ion-card-subtitle {
  padding: 7px;
  display: flex;
  font-size: 11px;
  align-items: center;
}
ion-card ion-card-header ion-card-subtitle .location-icon {
  margin-right: 2.5px;
}
ion-card ion-card-content {
  padding: 0px 8px 8px 8px;
}
ion-card ion-card-content ion-chip {
  padding-inline: 10px;
  font-size: 12px;
}
ion-card ion-card-content ion-chip ion-icon {
  margin-right: 3.5px;
}

.no-member-grid {
  height: 100%;
}

.no-member-row {
  height: 100%;
}

.location-text {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Show only 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
  max-height: 3em;
  cursor: pointer;
}

ion-popover.display-location {
  --width: 275px;
}
ion-popover.display-location ion-label {
  margin: 5px 10px;
}
ion-popover.display-location ion-label .displayLocation {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 7px 0;
  word-break: break-word;
}
ion-popover.display-location ion-label .displayLocation div {
  display: flex;
}
ion-popover.display-location ion-label .displayLocation {
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/find-colleague/find-colleague.component.scss"],"names":[],"mappings":"AAGA;EAII,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AALJ;AALI;EACE,gCAAA;AAON;AAGI;EACE,aAAA;AADN;AAEM;EACE,eAAA;EACA,cAAA;AAAR;AAGI;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AADN;AAGI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AADN;AAEM;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAEM;EACE,aAAA;AAAR;AACQ;EACE,eAAA;EACA,cAAA;AACV;;AAKE;EACE,mBAAA;EACA,qBAAA;EACA,8CAAA;EACA,iBAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;AAFJ;;AAIE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AADJ;;AAIE;EACE,OAAA;EACA,gBAAA;EACA,+CAAA;AADJ;;AAIE;EACE,OAAA;EACA,gBAAA;EACA,qBAAA;AADJ;;AAGE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;;AAEE;EACE,YAAA;AACJ;AAAI;EACE,eAAA;AAEN;AADM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;UAAA,0BAAA;EACA,uBAAA;AAGR;AAFQ;EACE,eAAA;EACA,kBAAA;AAIV;AAFQ;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AAIV;AAHU;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAKZ;AAJY;EACI,eAAA;EACA,wBAAA;EACA,iBAAA;AAMhB;AADQ;EACI,oBAAA;EACA,eAAA;EACA,eAAA;AAGZ;AAAM;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAER;AADQ;EACE,mBAAA;AAGV;AACI;EACE,wBAAA;AACN;AAAM;EACE,oBAAA;EACA,eAAA;AAER;AADQ;EACE,mBAAA;AAGV;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AACA;EACE,oBAAA;EACA,qBAAA,EAAA,sBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAEF;;AAAE;EACE,cAAA;AAGJ;AADI;EACI,gBAAA;AAGR;AAFQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;AAIZ;AAHY;EACI,aAAA;AAKhB;AADQ;EACG,eAAA;AAGX","sourcesContent":["// ion-content {\n//   padding-bottom: 20px !important;\n// }\n.attendee-item {\n    &:not(:last-child) {\n      border-bottom: 1px solid #e0e0e0;\n    }\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 3px 0;\n    margin: 0 20px;\n    font-weight: 600;\n    cursor: pointer;\n    border-radius: 4px;\n    .user-icon-container {\n      display: flex;\n      .user-icon {\n        font-size: 36px;\n        color: #ed143d;\n      }\n    }\n    ion-label {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n    .attendee-item-actions {\n      display: flex;\n      gap: 5px;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      margin-left: auto;\n      ion-badge {\n        padding: 6px 8px;\n        border-radius: 6px;\n        font-size: 10px;\n      }\n      .close-icon-container {\n        display: flex;\n        ion-icon {\n          font-size: 24px;\n          color: #ed143d;\n        }\n      }\n    }\n  }\n  \n  ion-searchbar {\n    --background: white;\n    --icon-color: #ed143d;\n    --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);\n    padding: 5px 10px;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background: white;\n  }\n  .split-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    gap: 16px\n  }\n  \n  .colleagues-section {\n    flex: 1;\n    overflow-y: auto;\n    border-bottom: 1px solid var(--ion-color-light);\n  }\n  \n  .bookings-section {\n    flex: 3;\n    overflow-y: auto;\n    padding-bottom: 120px;\n  }\n  .spinner-background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.15);\n    z-index: 999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  ion-card {\n    margin: 20px ;\n    ion-card-header{\n      padding: 0 10px;\n      ion-card-title {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        padding-inline-start: 10px;\n        justify-content: center;\n        .map-icon {\n          font-size: 40px;\n          padding-right: 8px;\n        }\n        ion-label {\n          font-size: 1rem;\n          flex-grow: 3;\n          margin-bottom: 5px;\n          small {\n            display: block;\n            color: #6e6e6e;\n            font-size: 12px;\n            margin-top: 5px;\n            font-weight: 500;\n            ion-icon {\n                font-size: 15px;\n                vertical-align: text-top;\n                margin-right: 3px;\n\n            }\n        }\n        }\n        .phone-icon {\n            margin:5px 0 0 auto;\n            font-size: 24px;\n            cursor: pointer;\n        }\n      }\n      ion-card-subtitle{\n        padding:7px;\n        display: flex;\n        font-size: 11px;\n        align-items: center;\n        .location-icon {\n          margin-right: 2.5px;\n        }\n      }\n    }\n    ion-card-content{\n      padding: 0px 8px 8px 8px;\n      ion-chip {\n        padding-inline:10px;\n        font-size: 12px;\n        ion-icon {\n          margin-right: 3.5px;\n        }\n      }\n    }\n  }\n.no-member-grid {\n  height: 100%;\n}\n\n.no-member-row {\n  height: 100%;\n}\n.location-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* Show only 2 lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  word-wrap: break-word;\n  max-height: 3em; \n  cursor: pointer; \n}\n  ion-popover.display-location {\n    --width: 275px;\n   \n    ion-label {\n        margin: 5px 10px;\n        .displayLocation {\n            display: flex;\n            align-items: center;\n            gap:5px;\n            margin: 7px 0;\n            word-break: break-word;\n            div {\n                display: flex;\n            }\n        }\n      \n        .displayLocation {\n           font-size: 15px;\n  \n        }\n       \n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
